import { render, staticRenderFns } from "./SellerRatingForm.vue?vue&type=template&id=8bc945c0&"
import script from "./SellerRatingForm.vue?vue&type=script&lang=js&"
export * from "./SellerRatingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports